<template>
	<div class="small-12 flex page propertyLeases popertyListingsLayout animated fadeIn" v-if="loaded && user">
		<primary-nav :user="user"/>
		<div class="small-12 large-10 pageContentWrap">
			<div class="small-12 pageContent">
				<div class="small-12 centerColumn">
					<div class="small-12 details">
						<div class="small-12 pageNav flex vertical-align border-bottom" v-if="property">
							<property-nav :property="property"/>
							<site-nav :user="user"/>
						</div>
						<div class="small-12 mainContent">
							<rent-listing :property="property" :user="user" :lease="lease" :resident="resident" :unit="unit" :company="company"/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<new-version-modal :show_modal="!user.attributes.has_latest_version" v-show="!user.attributes.has_latest_version"/>
	</div>
	<loading-spinner :loaded="loaded" v-else/>
</template>

<script>

	// Import the components
	import LoadingSpinner from '@/components/framework/helpers/LoadingSpinner.vue'
	import PrimaryNav from '@/components/framework/nav/PrimaryNav.vue'
	import SiteNav from '@/components/framework/nav/SiteNav.vue'
	import PropertyNav from '@/components/property/shared/PropertyNav.vue'
	import RentListing from '@/components/property/lease/rent/RentListing.vue'
	import NewVersionModal from '@/components/framework/modals/NewVersionModal.vue'

	// Import the events
	import { GetAppVersion } from '@/events/app/GetAppVersion'
	import { BindUser } from '@/events/users/BindUser'
	import { GetProperty } from '@/events/property/GetProperty'
	import { GetCompany } from '@/events/company/GetCompany'
	import { BindLease } from '@/events/leases/BindLease'
	import { GetPropertyResident } from '@/events/residents/GetPropertyResident'
	import { GetUnit } from '@/events/units/GetUnit'

	export default {

		/*
		** Set the component name
		*/

		name: 'Index',

		/*
		**  Register the components
		*/

		components: {

			LoadingSpinner,
			NewVersionModal,
			PrimaryNav,
			SiteNav,
			PropertyNav,
			RentListing

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			GetAppVersion,
			BindUser,
			GetProperty,
			GetCompany,
			BindLease,
			GetPropertyResident,
			GetUnit

		],

		/*
		**  Set up the data
		*/

		data: () => ({

			loaded: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			user: {

				immediate: true, // Load on created
				handler(user) {

					/*
                    ** Get the property
                    ** @event: Events/Properties/GetProperty
                    */

				   	if (user) this.getPropertyHandler();

					/*
                    ** Get the company
                    ** @event: Events/Company/GetCompany
                    */

				   	if (user && user.relationships.company) this.getCompanyHandler();

				}

			},

			property: {

				immediate: true, // Load on created
				handler(property) {

					/*
                    ** Get the lease
                    ** @event: Events/Leases/BindLease
                    */

				   	if (property) this.bindLeaseHandler(this.$route.params.id, this.$route.params.leaseID);

				}

			},

			lease: {

				immediate: true, // Load on created
				handler(lease) {

					/*
					** If a lease hasn't been deleted
					*/

					if (lease) {

						/*
						** Get the resident
						** @event: Events/Residents/GetPropertyResident
						*/

						this.getPropertyResidentHandler(lease.relationships.resident);

						/*
						** Get the unit
						** @event: Events/Units/GetUnit
						*/

						this.getUnitHandler(lease.relationships.unit);

					}

				}

			},

			unit: {

				immediate: true, // Load on created
				handler(unit) {

					/*
                    ** Set the prop
                    ** @prop: @here
                    */

					if (unit) this.loaded = true;

				}

			}

		},

		/*
		**  Do this first
		*/

		created() {

			/*
			**  Get the user
			**  @event: Events/Users/BindUser
			*/

			this.bindUserHandler();

		},

        /*
		**  Set up the methods
		*/

		methods: {

			//

		}

	}

</script>